import { cn } from '@/lib/tailwind-utils';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import * as React from 'react';

interface ButtonCheckboxProps extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> {
  secondaryLabel?: string;
  secondaryLabelClassName?: string;
  children?: React.ReactNode;
}

const ButtonCheckbox = React.forwardRef<React.ElementRef<typeof CheckboxPrimitive.Root>, ButtonCheckboxProps>(
  ({ className, secondaryLabel, secondaryLabelClassName, children, ...props }, ref) => (
    <div className="relative min-h-[4rem] inline-block">
      <div className="relative">
        <CheckboxPrimitive.Root
          ref={ref}
          className={cn(
            'peer h-10 min-w-[3rem] w-auto px-3 py-2 rounded-md border border-input text-center',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
            'disabled:cursor-not-allowed disabled:opacity-50',
            'data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground',
            'data-[state=unchecked]:bg-white data-[state=unchecked]:text-foreground',
            className,
          )}
          {...props}
        >
          <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current')} />
          <div style={{ color: 'currentColor' }} className="flex items-center justify-center pointer-events-none">
            {children}
          </div>
        </CheckboxPrimitive.Root>
      </div>
      {secondaryLabel && (
        <div
          className={cn(
            'mt-1 text-xs text-center text-muted-foreground',
            props.disabled && 'opacity-50',
            secondaryLabelClassName,
          )}
        >
          {secondaryLabel}
        </div>
      )}
    </div>
  ),
);

ButtonCheckbox.displayName = 'ButtonCheckbox';

export { ButtonCheckbox };
